import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BitmapText, Container } from '@pixi/react';
import { getBitmapTextDimensions } from '../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../utils/utils';
import { ActiveTimerBar } from './activeTimerBar';
const PADDING_PX = 4;
const FOREGROUND_TEXT_STYLE_TYPE = 'active-timer-foreground-text';
const BACKGROUND_TEXT_STYLE_TYPE = 'active-timer-background-text';
/**
 * Renders an active timer bar that is centered on the provided coordinates, and adjusts its size based on the rendered text dimensions.
 */
export const AutoSizingTextActiveTimerBar = ({ x: centerX, y: centerY, text, startTimestampMs, totalMs, timerBarPixiData, textPixiDataType }) => {
    const dimensions = getBitmapTextDimensions(text, FOREGROUND_TEXT_STYLE_TYPE);
    const textX = Math.round(-dimensions.w / 2);
    const textY = Math.round(-dimensions.h / 2);
    const timerBarX = textX - PADDING_PX;
    const timerBarY = textY - PADDING_PX;
    const backgroundTextComponent = (_jsx(Container, { alpha: 0.5, children: _jsx(BitmapText, { text: text, style: { fontName: BACKGROUND_TEXT_STYLE_TYPE }, x: textX, y: textY }) }));
    const foregroundTextComponent = (_jsx(BitmapText, { "pixi-data": isTestEnvironment() ? { type: textPixiDataType } : null, text: text, style: { fontName: FOREGROUND_TEXT_STYLE_TYPE }, x: textX, y: textY }));
    return (_jsxs(Container, { interactiveChildren: false, x: centerX, y: centerY, children: [_jsx(ActiveTimerBar, { startTimestampMs: startTimestampMs, totalMs: totalMs, x: timerBarX, y: timerBarY, w: dimensions.w + 2 * PADDING_PX, h: dimensions.h + 2 * PADDING_PX, pixiData: timerBarPixiData }), backgroundTextComponent, foregroundTextComponent] }));
};
